import moment from 'moment-timezone';
import { EChartOption } from 'echarts/lib/echarts';
import { convertEventDataToChart, renderEventItem } from '../../../utils/converDataToChart';
import generateGraphic from '../../../utils/generateGraphic';
import { renameAllShortInAString } from '@src/utils/common';

const TooltipFormatStyle = 'ddd, MMM DD, YYYY HH:mm:ss';

const eventTooltipFormatter = (data) => {
  const res: string[] = [];
  data.forEach(({ time, value }) => {
    const timeShow = moment(time).format(TooltipFormatStyle);
    const valueShow = typeof value === 'object' ? JSON.stringify(value) : value;
    res.push(
      `<tr><td class="ts">${timeShow}</td><td class="value">${renameAllShortInAString(valueShow)}</td></tr>`,
    );
  });

  return `<table class="event-table">${res.join('')}</table>`;
};

export default ({ range, eventData, dateRange, chartWidth, granularity }): EChartOption => {
  const eventChartData = convertEventDataToChart(eventData, range, dateRange);
  const min = dateRange[0];
  const max = dateRange[dateRange.length - 1];
  const option: EChartOption = {
    tooltip: {
      show: true,
    },
    grid: [
      {
        show: false,
        left: 30,
        right: 95,
      },
    ],
    graphic: generateGraphic({ y: 0, x: 30, width: chartWidth }, {}, { top: 25 }),
    xAxis: [
      {
        type: 'time',
        show: false,
        min,
        max,
        data: dateRange,
      },
    ],
    yAxis: {
      show: false,
    },
    series: [
      {
        type: 'custom',
        renderItem: (p, a) => renderEventItem(p, a, min, max),
        data: eventChartData,
        xAxisIndex: 0,
        encode: {
          x: 0,
          y: 0,
        },
        tooltip: {
          formatter: (params) => {
            const [, , details] = params.data.value;

            return eventTooltipFormatter(details);
          },
        },
      },
    ],
  };
  return option;
};
